
import React, { useRef, useEffect } from "react";

function useOutsideClickCapture(ref, onClick) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref && ref.current && !ref.current.contains(event.target)) {
          //console.log("tes"); //  //  alert("You clicked outside of me!");
          //console.log();
          onClick();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onClick]);
  }

  export default useOutsideClickCapture;